import { render, staticRenderFns } from "./tenant_config_notifications.vue?vue&type=template&id=22fc5869&"
import script from "./tenant_config_notifications.vue?vue&type=script&lang=js&"
export * from "./tenant_config_notifications.vue?vue&type=script&lang=js&"
import style0 from "./tenant_config_notifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports